var map = {
	"./tapcoin/new/TAP-small.png": 24460,
	"./tapcoin/new/TAPCOINS-small.png": 9474,
	"./tapcoin/new/TAPSTOCK-small.png": 12337,
	"./tapcoin/new/USDT-small.png": 4943,
	"./tapcoin/new/game-small.png": 76050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74871;